import { render, staticRenderFns } from "./DatatablePagination.vue?vue&type=template&id=61837739&scoped=true&"
import script from "./DatatablePagination.vue?vue&type=script&lang=js&"
export * from "./DatatablePagination.vue?vue&type=script&lang=js&"
import style0 from "./DatatablePagination.vue?vue&type=style&index=0&id=61837739&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61837739",
  null
  
)

export default component.exports